import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-tails-bold",
  "use": "icon-arrow-right-tails-bold-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol viewBox=\"0 0 16 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-tails-bold\">\n<path id=\"icon-arrow-right-tails-bold_Vector\" d=\"M8.56472 9.20537L0.783512 9.20537C0.352221 9.20537 0 8.86641 0 8.45136V5.43532C0 5.02027 0.352221 4.68131 0.783512 4.68131H8.56472V1.35398C8.56472 0.938933 8.91335 0.599976 9.34823 0.599976C9.55669 0.599976 9.75796 0.679527 9.90532 0.821336L15.7709 6.46949C16.0764 6.76348 16.0764 7.24079 15.7709 7.53479L9.90172 13.1795C9.59623 13.4735 9.10024 13.4735 8.79474 13.1795C8.64739 13.0377 8.56472 12.844 8.56472 12.6434V9.20537Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-right-tails-bold.svg
// module id = vccG
// module chunks = 258